import http from "../../http-common";
/* eslint-disable */
class DireksiService {
  direksiList(page, itemPerPage, keyword, dpd) {
    return http.get(
      "/direksi/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&dpd_id=" +
        dpd,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);

    if (data.selectedJabatan && data.selectedJabatan != undefined) {
      bodyFormData.append("jabatan", data.selectedJabatan.code);
    }

    if (data.selectedDpd && data.selectedDpd != undefined) {
      bodyFormData.append("dpd_id", data.selectedDpd.id);
    }

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/direksi", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);

    if (data.selectedJabatan && data.selectedJabatan != undefined) {
      bodyFormData.append("jabatan", data.selectedJabatan.code);
    }

    if (data.selectedDpd && data.selectedDpd != undefined) {
      bodyFormData.append("dpd_id", data.selectedDpd.id);
    }

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/direksi/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/direksi/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new DireksiService();
